import { Settings } from "lucide-react";
import { Card } from "../../ui/card";
import { EmptyCard, ErrorCard, Field, LoadingBlock, Pill } from "../AdminBits";
import useAdminFetch from "../../../hooks/useAdminFetch";
import { CONFIG_GROUPS, configValue, openingHours } from "../../../lib/jamoraAdmin";

// What Jamora lets the CRM read of a pharmacy's settings. Secrets, the stamp, the WhatsApp link and the footer messages are not part of it.
export default function ConfigTab({ schema }) {
  const { phase, data, error, reload } = useAdminFetch(`/pharmacies/${schema}/config`);
  if (phase === "loading" || phase === "idle") return <LoadingBlock rows={4} />;
  if (phase === "error") return <ErrorCard message={error} onRetry={reload} />;
  const config = data.config;
  if (!config) return <EmptyCard icon={Settings} testid="config-empty" title="Aucune configuration" hint="Cette pharmacie n'a pas encore de configuration enregistrée." />;
  const hours = openingHours(config.horaires);
  return (
    <div className="space-y-4" data-testid="pharmacy-config">
      <div className="grid gap-4 lg:grid-cols-2">
        {CONFIG_GROUPS.map((group) => (
          <Card key={group.id} className="p-4" data-testid={`config-${group.id}`}>
            <h2 className="text-sm font-semibold text-slate-900 mb-1">{group.title}</h2>
            <dl className="divide-y divide-slate-100">
              {group.fields.map(([key, label, kind]) => (
                <Field key={key} label={label}>
                  {kind === "bool" ? <Pill tone={config[key] ? "emerald" : "slate"}>{config[key] ? "Oui" : "Non"}</Pill> : configValue(kind, config[key])}
                </Field>
              ))}
              {group.id === "start" && hours.map(([day, text]) => <Field key={day} label={day}>{text}</Field>)}
              {group.id === "start" && <Field label="WhatsApp">{config.whatsapp_connected ? "Compte relié" : "Aucun compte relié"}</Field>}
            </dl>
          </Card>
        ))}
      </div>
    </div>
  );
}
